import { render } from "./SuggestionsBody.vue?vue&type=template&id=ea4d44ae&scoped=true"
import script from "./SuggestionsBody.vue?vue&type=script&lang=js"
export * from "./SuggestionsBody.vue?vue&type=script&lang=js"

import "./SuggestionsBody.vue?vue&type=style&index=0&id=ea4d44ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea4d44ae"]])

export default __exports__